import { defineMessages } from "react-intl"

export default defineMessages({
  pageTitle: {
    id: "app.pages.terms.pageTitle",
  },
  PERSONAL_DATA_COLLECT_TITLE: {
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_TITLE",
  },
  PERSONAL_DATA_COLLECT_1_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_1_Q",
  },
  PERSONAL_DATA_COLLECT_1_A:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_1_A",
  },
  PERSONAL_DATA_COLLECT_2_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_2_Q",
  },
  PERSONAL_DATA_COLLECT_2_A:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_2_A",
  },
  PERSONAL_DATA_COLLECT_3_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_3_Q",
  },
  PERSONAL_DATA_COLLECT_3_A:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_3_A",
  },
  PERSONAL_DATA_COLLECT_4_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_4_Q",
  },
  PERSONAL_DATA_COLLECT_4_A:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_4_A",
  },
  PERSONAL_DATA_COLLECT_5_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_5_Q",
  },
  PERSONAL_DATA_COLLECT_5_A:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_5_A",
  },
  PERSONAL_DATA_COLLECT_OTHER_Q:{
    id:"app.pages.terms.PERSONAL_DATA_COLLECT_OTHER_Q",
  }
})
